import { AppContainer, getAppContainer } from "../container";

export const useContainer = (): AppContainer => getAppContainer();
